import React, {useContext} from 'react'
import { 
  Box, 
  Flex, 
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
} from "@chakra-ui/react";
import { ExternalLinkIcon } from '@chakra-ui/icons'
import { Routes, Route } from "react-router";
import { UpdateCoursePage } from '../../pages/UpdateCoursePage';
import { HomePage } from '../../pages/HomePage';
import { DraftsPage } from '../../pages/DraftsPage';
import { CatalogsPage } from '../../pages/CatalogsPage';
import { MyDynosPage } from '../../pages/MyDynosPage';
import { StoreSettingsPage } from '../../pages/StoreSettingsPage';
import { CreateCatalogPage } from '../../pages/CreateCatalogPage';
import { UpdateBookPage } from '../../pages/UpdateBookPage';
import { ProductsPage } from '../../pages/ProductsPage';
import { StaffPage } from '../../pages/StaffPage';
import { ContentPage } from '../../pages/ContentPage';
import { InstructorsPage } from '../../pages/InstructorsPage';
import { CreateNewDynoPage } from '../../pages/CreateNewDynoPage';
import { CreateNewAIDynoWithTemplatePage } from '../../pages/CreateNewAIDynoWithTemplatePage';
import { Layout } from '../../layout';
import { ResourcesPage } from '../../pages/ResourcesPage';
import { StripeAccountManagementPage } from '../../pages/StripeAccountManagementPage';
import { NotificationProvider } from '../../contexts/NotificationProvider';
import { StripePaymentsPage } from '../../pages/StripePaymentsPage';
import { StripePayoutPage } from '../../pages/StripePayoutPage';
import { PublisherAndUserContext } from '../../contexts/PublisherAndUserContext';
import { BreadcrumbNavs } from '../BreadcrumbNavs';
import { BreadcrumbProvider } from '../../contexts/BreadcrumbProvider';
import { StripeCouponPage } from '../../pages/StripeCouponPage';
import { StripeReturnURLPage } from '../../pages/StripeReturnURLPage';
import { CreateBookPage } from '../../pages/CreateBookPage';
import { CreateCoursePage } from '../../pages/CreateCoursePage';
import { PricingPlan } from '../../pages/PricingPlan';
import { TokenUsagePage } from '../../pages/TokenUsagePage';
import { PaymentSuccess } from '../../pages/PaymentSuccess';
import PaymentFailed from '../../pages/PaymentFailed';
import { Billing } from '../../pages/Billing';
import { HelpPage } from '../../pages/HelpPage';
import { IntegrationsPage } from '../../pages/IntegrationsPage';
import { AnalyticsPage } from '../../pages/AnalyticsPage';
import { EngagementPage } from '../../pages/EngagementPage';

export const SectionMain = () => {
  const {userRole, publisher} = useContext(PublisherAndUserContext);
  return (
    <NotificationProvider>
      <BreadcrumbProvider>
        <Layout>
          <Box className="container">
            <Flex justifyContent="space-between">
              <BreadcrumbNavs />
              {
                publisher?.otherInfo?.isBuildComplete ?
                  <Button rightIcon={<ExternalLinkIcon />} variant="link" size='sm' onClick={() => window.open(`https://${publisher?.domainName}.myedshop.com`, '_blank')}>
                    Visit Your Edshop
                  </Button>
                  : <Popover>
                    <PopoverTrigger>
                      <Button rightIcon={<ExternalLinkIcon />} size='sm' variant="link">
                        Visit Your Edshop
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent>
                      <PopoverArrow />
                      <PopoverBody>Please update the required fields in the store settings page to build your website. Once built you can visit the website</PopoverBody>
                    </PopoverContent>
                  </Popover>
              }
            </Flex>
            <Routes>
              <Route path="/" element={<HomePage />} />
              {/* <Route path="/createbook" element={<UpdateBookPage />} /> */}
              <Route path="/createbook/:step" element={<CreateBookPage/>} />
              <Route path="/updatebook/:pid/:cid" element={<UpdateBookPage />} />
              {/* <Route path="/createcourse" element={<UpdateCoursePage />} /> */}
              <Route path="/createcourse/:step" element={<CreateCoursePage/>} />
              <Route path="/updatecourse/:pid/:cid" element={<UpdateCoursePage />} />
              <Route path="/createcatalog" element={<CreateCatalogPage />} />
              <Route path="/updatecatalog/:id" element={<CreateCatalogPage />} />
              <Route path="/catalogs" element={<CatalogsPage />} />
              <Route path="/catalog/:id" element={<ProductsPage />} />
              <Route path="/myeddocs" element={<MyDynosPage />} />
              <Route path="/mydrafts" element={<DraftsPage />} />
              <Route path="/content/:id" element={<ContentPage />} />
              <Route path="/createeddoc" element={<CreateNewDynoPage />} />
              <Route path="/createwithtemplate" element={<CreateNewAIDynoWithTemplatePage />} />
              <Route path="/resources" element={<ResourcesPage />} />
              <Route path="/help" element={<HelpPage />} />
              {!userRole?.isStaff && <Route path="/instructors" element={<InstructorsPage />} />}
              {!userRole?.isStaff && <Route path="/storesettings" element={<StoreSettingsPage />} />}
              {!userRole?.isStaff && <Route path="/staff" element={<StaffPage />} />}
              {userRole?.isOwner && <Route path="/manageaccount" element={<StripeAccountManagementPage />} />}
              {!userRole?.isStaff &&  <Route path="/payments" element={<StripePaymentsPage />} />}
              {!userRole?.isStaff &&  <Route path="/payouts" element={<StripePayoutPage />} />}
              {!userRole?.isStaff &&  <Route path="/coupons" element={<StripeCouponPage />} />}
              {!userRole?.isStaff &&  <Route path="/engagement" element={<EngagementPage />} />}
              {!userRole?.isStaff &&  <Route path="/analytics" element={<AnalyticsPage />} />}
              {!userRole?.isStaff &&  <Route path="/integrations" element={<IntegrationsPage />} />}
              {userRole?.isOwner &&  <Route path="/expiredlink" element={<StripeReturnURLPage />} />}
              {userRole?.isOwner &&  <Route path="/pricingplan" element={<PricingPlan />} />}
              <Route path="/credits-info" element={<TokenUsagePage id={publisher?.id} isPro={publisher?.isPro} />} />
              {userRole?.isOwner &&  <Route path="/pricingplan" element={<PricingPlan isPro={publisher.isPro}/>} />}
              {userRole?.isOwner &&  <Route path="/success" element={<PaymentSuccess />} />}
              {userRole?.isOwner &&  <Route path="/fail" element={<PaymentFailed />} />}
              {userRole?.isOwner &&  <Route path="/billing" element={<Billing />} />}
            </Routes>
          </Box>
        </Layout>
      </BreadcrumbProvider>
    </NotificationProvider>
  )
}
